var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 59,
    viewBox: "0 0 67 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.572 19.073c-2.655-3.571-7.977-3.824-9.988-3.904h-.069c-1.638-.011-3.269.232-4.83.72-1.367.359-3.16.799-5.896 1.332-3.476.42-6.991.42-10.467 0 .47-1.398.787-2.841.944-4.304.507-4.624-.219-7.995-2.216-10.153A8.928 8.928 0 0 0 29.937.66 9.134 9.134 0 0 0 26.21.005h-.137c-5.951 0-9.016 7.662-9.454 10.487a15.571 15.571 0 0 0-.123 2.798c0 1.825 0 3.57-2.422 7.115a11.58 11.58 0 0 0-8.346 1.146C2.115 23.723.254 27.973.022 34.196c-.274 10.06 3.502 17.734 9.577 19.547a8.52 8.52 0 0 0 3.922.224 8.415 8.415 0 0 0 3.59-1.557c2.53 1.492 6.197 2.345 11.465 1.333 1.901 2.664 4.583 5.222 8.907 5.222.725-.003 1.448-.07 2.161-.2 4.707-.812 6.198-2.797 7.443-5.516a10.715 10.715 0 0 0 4.42-3.744 7.46 7.46 0 0 0 1.135-5.33 14.544 14.544 0 0 0 2.983-5.329 10.58 10.58 0 0 0 .424-3.571 13.826 13.826 0 0 0 6.564-3.169 13.288 13.288 0 0 0 3.944-6.012 7.642 7.642 0 0 0 .369-3.625 7.717 7.717 0 0 0-1.355-3.396z",
    fill: "#F4F2F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.882 35.648s-3.558-4.636 2.243-12.191c5.268-6.876 3.49-9.447 3.968-12.525.342-2.145 2.737-7.568 5.98-7.502 3.474 0 6.443 1.533 5.622 9.047a15.145 15.145 0 0 1-1.852 6.066 15.555 15.555 0 0 1-4.195 4.834",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.931 19.978s10.317 1.732 16.5.653c6.185-1.08 7.786-2.052 9.92-1.945 2.135.106 9.496.36 7.717 6.436-1.779 6.075-9.017 7.994-13.586 6.662a15.055 15.055 0 0 0-7.635-.56M30.313 26.161s-.246 10.953-12.012 11.459M11.077 40.085s1.368 4.837 4.72 5.93",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.593 41.27s-.11 12.832 15.46 8.475",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.386 24.402s-11.465-5.33-11.875 9.78c-.41 15.11 8.838 20.173 13.271 13.325M26.47 38.846s2.735-.146 3.844 1.24M47.32 34.355s-10.822-8.74-13.094.187c-2.27 8.927 4.762 5.49 6.745 5.783 1.984.293 6.486 1.532 7.348 2.465.862.932 6.991-6.463 2.476-10.753",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.87 38.593s-4.104 3.664-1.121 5.73c2.982 2.065 10.549 5.929 11.67 6.022 1.122.093 6.842-2.905 3.9-7.555",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.243 43.87s-3.654 3.13-1.52 6.661c2.135 3.531 4.31 5.476 8.21 4.784 3.9-.693 4.105-2.026 5.473-4.944",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.daff5a0e7a75a4ced205684d41c25bd3.svg";
export { ForwardRef as ReactComponent };